import React, { useContext } from 'react'
import { Card, CardHeading, CardContent, CardFooter } from '../../components/layout/Card'

import { RiskExplanation } from './RiskExplanation'
import { RiskBreakdown } from './RiskBreakdown'
import { ActionablesContext } from '../../contexts/ActionablesContext'
import { Button } from '../../components/Button'
import Box from '@material-ui/core/Box'

export const ImplementedPlanRisk = (props) => {
  const { location, frozen } = useContext(ActionablesContext)

  return (
    <Card className='ui-card--risk-profile'>
      <CardHeading>
        <h5>View your risk profile
        <span>Your <b>{props.riskProfile.selected === 'simple' ? 'Simple risk' : 'Detailed risk' }</b> is currently being used.</span>
        </h5>
      </CardHeading>
      <CardContent>
        <div className='risk-profile'>
          <RiskExplanation {...props} />
          <RiskBreakdown {...props} />
        </div>
      </CardContent>
      {location === 'implementedPlan' && !frozen &&
        <CardFooter>
          <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
          >
            <p>You can retake your risk questionnaire in scenario planning</p>
            <Button
              primary
              trackAs='Read only risk: New scenario'
              onClick={() => props.onCreateNewScenario()}
            >
              Create a new scenario
            </Button>
          </Box>
        </CardFooter>
      }
    </Card>
  )
}
